import React from 'react';
import { Link } from 'react-router-dom';
import { PageLayout } from '../components/Layout';
import { ExternalLink, Heart, Coins, Globe } from 'lucide-react';

const GRANTS = [
  { name: 'Turn2us Grants Search', url: 'https://grants-search.turn2us.org.uk/' },
  { name: 'Glasspool Charity Trust', url: 'https://www.glasspool.org.uk/' },
  { name: 'Smallwood Trust', url: 'https://www.smallwoodtrust.org.uk/' },
  { name: "Barchester's Charitable Foundation", url: 'https://www.bhcfoundation.org.uk/' },
  { name: 'Thomas Wall Trust', url: 'https://www.thomaswalltrust.org.uk/' },
  { name: 'Esmée Fairbairn Foundation', url: 'https://esmeefairbairn.org.uk/apply-for-a-grant/' },
  { name: 'Greggs Foundation', url: 'https://www.greggsfoundation.org.uk/grants' },
  { name: 'New UK Charitable Trusts 2025', url: 'https://www.charityexcellence.co.uk/new-uk-charitable-trusts-and-foundations/' },
];

const DEBT_ADVICE = [
  'MoneyHelper',
  'StepChange',
  'Citizens Advice',
  'National Debtline',
  'PayPlan',
  'Community Money Advice (CMA)',
];

export default function FinancialSupport() {
  return (
    <PageLayout showNav>
      <div className="px-4 py-6 max-w-lg mx-auto space-y-6">
        <div>
          <Link to="/settings" className="text-primary text-sm hover:underline">
            ← Back to Settings
          </Link>
          <h1 className="font-heading font-bold text-dark text-2xl mt-2">
            Financial Support & Grants
          </h1>
        </div>

        {/* Grants Section */}
        <div className="card-default overflow-hidden">
          <div className="p-4 border-b border-border bg-primary-light">
            <div className="flex items-center gap-2">
              <Coins className="w-5 h-5 text-primary" />
              <h2 className="font-semibold text-dark">Grants & Financial Help</h2>
            </div>
          </div>
          <div className="divide-y divide-border">
            {GRANTS.map((grant, i) => (
              <a
                key={i}
                href={grant.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
                data-testid={`grant-link-${i}`}
              >
                <span className="text-text-primary font-medium">{grant.name}</span>
                <ExternalLink className="w-4 h-4 text-primary" />
              </a>
            ))}
          </div>
        </div>

        {/* Debt Advice Section */}
        <div className="card-default overflow-hidden">
          <div className="p-4 border-b border-border bg-gold-light">
            <div className="flex items-center gap-2">
              <Heart className="w-5 h-5 text-gold" />
              <h2 className="font-semibold text-dark">Debt & Money Advice</h2>
            </div>
          </div>
          <div className="p-4">
            <p className="text-text-secondary text-sm mb-4">
              Search on your mobile for the nearest organisation in your location:
            </p>
            <div className="space-y-2">
              {DEBT_ADVICE.map((org, i) => (
                <div
                  key={i}
                  className="p-3 bg-gray-50 rounded-lg text-text-primary font-medium"
                >
                  {org}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* International Section */}
        <div className="card-default overflow-hidden">
          <div className="p-4 border-b border-border bg-primary-light">
            <div className="flex items-center gap-2">
              <Globe className="w-5 h-5 text-primary" />
              <h2 className="font-semibold text-dark">International Support</h2>
            </div>
          </div>
          <a
            href="https://www.kiva.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            data-testid="kiva-link"
          >
            <span className="text-text-primary font-medium">Kiva</span>
            <ExternalLink className="w-4 h-4 text-primary" />
          </a>
        </div>

        {/* Disclaimer */}
        <div className="p-4 bg-alert-light rounded-2xl">
          <p className="text-sm text-text-secondary text-center">
            These services are independent and not affiliated with My Direct Debits.
          </p>
        </div>
      </div>
    </PageLayout>
  );
}
